module.exports = __webpack_public_path__ + "img/sleeve upper arm width.ce856bb1.png";